import React from "react";
import { FaCode, FaLightbulb, FaHandshake, FaCheckCircle } from "react-icons/fa";

export default function FeatureHighlights() {
  const features = [
    {
      title: "Technical Excellence",
      text: "Every line of code is crafted with precision and purpose.",
      icon: <FaCode />,
    },
    {
      title: "Creative Innovation",
      text: "We push boundaries to deliver truly unique solutions.",
      icon: <FaLightbulb />,
    },
    {
      title: "Client Partnership",
      text: "Your success is our success. We work as an extension of your team.",
      icon: <FaHandshake />,
    },
    {
      title: "Quality First",
      text: "We never compromise on quality, performance, or user experience.",
      icon: <FaCheckCircle />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-14">
      {features.map((item, index) => (
        <div
          key={index}
          className="group relative overflow-hidden bg-[#071B22]/80 border border-[#00FF88]/10 p-7 rounded-tl-[44px] rounded-tr-[12px] rounded-bl-[12px] rounded-br-[44px] transition-all duration-500 hover:border-[#00FF88]/40 hover:shadow-[0_0_40px_rgba(0,255,136,0.15)]"
        >
          {/* Neon Glow Layer */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#00FF88]/10 to-[#00CFFF]/10 opacity-0 group-hover:opacity-100 transition duration-500" />

          {/* Icon */}
          <div className="relative z-10 w-12 h-12 flex items-center justify-center rounded-full bg-[#00FF88]/10 text-[#00FF88] text-xl mb-4 shadow-[0_0_20px_rgba(0,255,136,0.25)]">
            {item.icon}
          </div>

          {/* Title */}
          <h3 className="relative z-10 font-semibold text-xl mb-2 text-white">
            {item.title}
          </h3>

          {/* Description */}
          <p className="relative z-10 text-sm text-white/70 leading-relaxed max-w-sm">
            {item.text}
          </p>

          {/* Accent Corner */}
          <span className="absolute top-4 right-4 w-2 h-2 rounded-full bg-[#00FF88] shadow-[0_0_12px_#00FF88]" />
        </div>
      ))}
    </div>
  );
}
